<template>
    <div class="layout-profile">
        <button class="p-link layout-profile-link" @click="onClick">
            <div class="username-avatar">
                <span>{{ nameLetter }}</span>
                <span>{{ surenameLetter }}</span>
            </div>
            <div class="username">
                {{ username }}
            </div>
            <i class="icon-arrow-down1"></i>
        </button>
        <transition name="layout-submenu-wrapper">
            <ul v-show="expanded">
                <li><button class="p-link" :class="{ 'profile-link-active': $route.path == '/user/profile' }" @click="$router.push('/user/profile')"><span>Account</span></button></li>
              
            </ul>
        </transition>
        <!-- <Dialog header="Are you sure?" :visible.sync="confirmDialog" :style="{width: '30vw'}" :modal="true">
            <span>Are you sure you want to log out?</span>
            <template #footer>
                <Button label="Log out" @click="logout()" icon="pi pi-check" class="p-button"/>
            </template>
        </Dialog> -->
    </div>
</template>

<script>
    export default {
        data() {
            return {
                username: null,
                expanded: true,
                confirmDialog: false
            }
        },
        created() {
            // if (this.$store.state.currentUser.company == null) {
            //     }
            // else {
            //     console.log(this.$store.state.currentUser);
            //     this.username = this.$store.state.currentUser.email
            // }
            this.username = this.$store.state.currentUser.name + " " + this.$store.state.currentUser.surname
            this.nameLetter = this.$store.state.currentUser.name.split('')[0];
            this.surenameLetter = this.$store.state.currentUser.surname.split('')[0];
        },
        methods: {
            onClick(event) {
                this.expanded = !this.expanded;
                event.preventDefault();
            },
            confirmLogout() {
                this.confirmDialog = true
            },
            logout() {
                this.confirmDialog = false
                this.$store.commit('logOut')
            }
        }
    }
</script>

<style scoped>
</style>